import { CurbsideModel } from '@/models/CurbsideModel';
import { CurbsideRequestRawModel } from '@/api/api-raw-models/curbside-request-raw-model';

/* eslint-disable @typescript-eslint/camelcase */
export const mapCurbsideRequest = (e: CurbsideModel): CurbsideRequestRawModel => ({
  curbside_pickup: true,
  curbside_model: e.curbsideModel,
  curbside_make: e.curbsideMake,
  curbside_color: e.curbsideColor,
});
